import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import DonMessage from '@/utils/message'
import { publicBusyUrl } from '@/utils/hostsconfig'

const service = axios.create({
  baseURL: '/',
  timeout: 10000, // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

service.interceptors.request.use(config => {
  // console.log(config)
  if(!config.multi){
    config.data = qs.stringify(config.data)
  }
  
  if (!config.baseURL.includes('check-video') && getToken()) {
    config.headers.Token = getToken()
  }

  if (sessionStorage.getItem('yx_token') && !config.url.includes('school/getChannelInfo')){
    config.headers['yx-token'] = sessionStorage.getItem('yx_token');
  }

  if (sessionStorage.getItem('teacher_id') && !config.url.includes('school/getChannelInfo')) {
    config.headers['Songshu-Uid'] = sessionStorage.getItem('teacher_id')
  }

  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    if (response.data.code == -9999997) {    //登陆过期
      localStorage.clear()
      const language = sessionStorage.getItem('Select-language');
      let errorMsg = response.data.msg || '网络延迟，请刷新！'
      if (language == 'en') {
        errorMsg = 'Login has expired';
      }
      DonMessage.error(errorMsg)
    } else if (response.data.code === 90000) {
      // 系统繁忙，去排队页面
      const teacher_info = JSON.parse(sessionStorage.getItem('TEACHER_INFO'))
      const { uid, yx_token } = teacher_info
      const sn =  '';
      let params = `?requestUrl=${response.request.responseURL}&method=${response.config.method}&accountId=${uid || ''}&sn=${sn}&token=${yx_token || ''}`
      window.location.href = publicBusyUrl + params
    }
    return response.data
  },
  error => {
    console.log('err' + error)// for debug
    if (typeof error.msg != 'undefined'){
      const language = sessionStorage.getItem('Select-language');
      let errorMsg = response.data.msg || '网络延迟，请刷新！'
      if (language == 'en') {
        errorMsg = 'system error';
      }
      DonMessage.error(errorMsg)
    }
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js